var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02795 10.9501C1.91924 11.6024 2.13222 12.267 2.5998 12.7345L11.2656 21.4003C12.0652 22.1999 13.3616 22.1999 14.1612 21.4003L21.4004 14.1612C22.2 13.3616 22.2 12.0652 21.4004 11.2655L12.7346 2.59973C12.267 2.13216 11.6024 1.91918 10.9501 2.02789L4.74517 3.06205C3.88219 3.20588 3.20594 3.88213 3.06211 4.74511L2.02795 10.9501ZM8.46442 10.4644C7.35985 10.4644 6.46442 9.56889 6.46442 8.46433C6.46442 7.35976 7.35985 6.46433 8.46442 6.46433C9.56899 6.46433 10.4644 7.35976 10.4644 8.46433C10.4644 9.56889 9.56899 10.4644 8.46442 10.4644Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.f1fbb2d09c9c106642dd15deea36a369.svg";
export { ForwardRef as ReactComponent };